import api from './api';

export const retrieveInsta = (username, config) => {
    let errors = [];
    if (!username) {
        errors.push('username');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Social/RetrieveInsta/${username}`, config);
    }
}

export const getTikTokPosts = (tikTokData, config) => {
    let errors = [];
    if (!tikTokData) {
        errors.push('tikTok data');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Social/FetchTikTokPosts/${tikTokData.uid}`, config);
    }
}

export const getTwitterPosts = (twitterData, config) => {
    let errors = [];
    if (!twitterData) {
        errors.push('twitter data');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Social/FetchTwitterPosts/${twitterData.username}`, config);
    }
}

export const retrieveUserInsta = (username, lastId, config) => {
    let errors = [];
    if (!username) {
        errors.push('username');
    }
    if (!lastId) {
        errors.push('last ID');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Social/RetrieveInsta/${username}/${lastId}`, config);
    }
}

export const fetchUserTikTokPosts = (tikTokData, lastId, config) => {
    let errors = [];
    if (!lastId) {
        errors.push('last ID');
    }
    if (!tikTokData) {
        errors.push('tikTok data');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Social/FetchTikTokPosts/${tikTokData.uid}/${lastId}`, config);
    }
}

export const fetchUserTwitterPosts = (twitterData, lastId, config) => {
    let errors = [];
    if (!twitterData) {
        errors.push('twitter data');
    }
    if (!lastId) {
        errors.push('last ID');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Social/FetchTwitterPosts/${twitterData.username}/${lastId}`, config);
    }
}

export const addCartItem = (loggedUser, token, products) => {
    let errors = [];
    if (!loggedUser) {
        errors.push('Logged user');
    }
    if (!token) {
        errors.push('token');
    }
    if (!products) {
        errors.push('products');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return fetch(`${process.env.REACT_APP_URL}/Cart/AddCartItems/${loggedUser?.id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(products)
        })
    }
}
